import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-[#0A0A0A] to-[#1a1a2e] text-white py-10 sm:py-14">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-black">🔒 Gizlilik Politikası</h1>
          <p className="text-gray-400 mt-2">Son güncelleme: 28 Temmuz 2026</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl border border-gray-100 p-6 sm:p-10 space-y-8">
          
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">1. Giriş</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              T-RaX Car Care ("Şirket", "biz", "bize" veya "bizim"), müşterilerinin gizliliğini ciddiye alır. 
              Bu Gizlilik Politikası, web sitemizi (traxcarcareproducts.com) ziyaret ettiğinizde ve 
              hizmetlerimizi kullandığınızda kişisel verilerinizi nasıl topladığımızı, kullandığımızı, 
              sakladığımızı ve paylaştığımızı açıklar.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">2. Toplanan Veriler</h2>
            <p className="text-sm text-gray-600 leading-relaxed mb-3">Aşağıdaki kişisel verileri toplayabiliriz:</p>
            <ul className="list-disc list-inside text-sm text-gray-600 space-y-2 ml-4">
              <li><strong>Kimlik Bilgileri:</strong> Ad, soyad, e-posta adresi, telefon numarası</li>
              <li><strong>Adres Bilgileri:</strong> Fatura ve teslimat adresi, posta kodu, şehir/ilçe</li>
              <li><strong>Ödeme Bilgileri:</strong> Kredi kartı bilgileri (Paytr 3D Secure ile güvenli şekilde işlenir, sunucularımızda saklanmaz)</li>
              <li><strong>İşlem Bilgileri:</strong> Sipariş geçmişi, tercihler</li>
              <li><strong>Teknik Veriler:</strong> IP adresi, tarayıcı türü, cihaz bilgileri, çerez verileri</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">3. Verilerin Kullanım Amacı</h2>
            <p className="text-sm text-gray-600 leading-relaxed mb-3">Toplanan veriler şu amaçlarla kullanılır:</p>
            <ul className="list-disc list-inside text-sm text-gray-600 space-y-2 ml-4">
              <li>Siparişlerinizi processing ve teslimatını sağlamak</li>
              <li>Ödeme işlemlerini yürütmek</li>
              <li>Müşteri hizmeti sunmak ve sorularınıza yanıt vermek</li>
              <li>Kargo takip bilgileri göndermek</li>
              <li>İade ve iptal taleplerinizi işlemek</li>
              <li>Yasal yükümlülüklerimizi yerine getirmek</li>
              <li>Hizmetlerimizi iyileştirmek</li>
              <li>İzin vermeniz halinde pazarlama iletişimi göndermek</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">4. Çerezler (Cookies)</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Web sitemiz, deneyiminizi geliştirmek için çerezler kullanır. Çerezler, tarayıcınız tarafından 
              cihazınıza yerleştirilen küçük metin dosyalarıdır. Kullandığımız çerez türleri:
            </p>
            <ul className="list-disc list-inside text-sm text-gray-600 space-y-2 ml-4 mt-3">
              <li><strong>Zorunlu Çerezler:</strong> Sepet ve oturum bilgileri için gereklidir</li>
              <li><strong>İşlevsellik Çerezleri:</strong> Dil tercihleri gibi ayarlarınızı hatırlar</li>
              <li><strong>Analitik Çerezler:</strong> Site kullanımını analiz ederek hizmeti iyileştirir</li>
            </ul>
            <p className="text-sm text-gray-600 leading-relaxed mt-3">
              Çerez tercihlerinizi tarayıcı ayarlarınızdan yönetebilirsiniz. Çerezleri devre dışı bırakmanız 
              durumunda某些网站功能可能无法正常工作。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">5. Veri Güvenliği</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Kişisel verilerinizin güvenliği bizim için önemlidir. Verilerinizi korumak için endüstri 
              standartlarında teknik ve idari önlemler alıyoruz. Ödeme işlemleri Paytr 3D Secure 
              sistemi üzerinden güvenli bir şekilde işlenir. Kredi kartı bilgileriniz sunucularımızda 
              saklanmaz.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">6. Veri Paylaşımı</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Kişisel verileriniz, yalnızca aşağıdaki durumlarda üçüncü taraflarla paylaşılabilir:
            </p>
            <ul className="list-disc list-inside text-sm text-gray-600 space-y-2 ml-4 mt-3">
              <li>Kargo ve lojistik şirketleri (sipariş teslimatı için)</li>
              <li>Ödeme kuruluşları (Paytr, güvenli ödeme için)</li>
              <li>Yasal zorunluluk durumunda yetkili merciler</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">7. Haklarınız (KVKK)</h2>
            <p className="text-sm text-gray-600 leading-relaxed mb-3">
              6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında aşağıdaki haklara sahipsiniz:
            </p>
            <ul className="list-disc list-inside text-sm text-gray-600 space-y-2 ml-4">
              <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
              <li>Kişisel verileriniz hakkında bilgi talep etme</li>
              <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
              <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme</li>
              <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde düzeltilmesini isteme</li>
              <li>Kişisel verilerinizin silinmesini veya yok edilmesini isteme</li>
              <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
              <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
            </ul>
            <p className="text-sm text-gray-600 leading-relaxed mt-3">
              Haklarınızı kullanmak için <a href="mailto:info@sbtkimya.com.tr" className="text-[#E31E24] hover:underline">info@sbtkimya.com.tr</a> 
              adresine e-posta gönderebilirsiniz.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">8. İletişim</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Bu Gizlilik Politikası hakkında sorularınız için bizimle iletişime geçebilirsiniz:
            </p>
            <div className="mt-3 text-sm text-gray-600 space-y-1">
              <p><strong>Şirket:</strong> T-RaX Car Care (SBT Kimya)</p>
              <p><strong>Adres:</strong> Yeni Birlik Sanayi Sitesi, Saray, 675. Cadde No:24/12, 06980 Kahramankazan/Ankara</p>
              <p><strong>E-posta:</strong> <a href="mailto:info@sbtkimya.com.tr" className="text-[#E31E24] hover:underline">info@sbtkimya.com.tr</a></p>
              <p><strong>Telefon:</strong> 0312 815 11 65</p>
            </div>
          </section>
        </div>

        <div className="mt-8 text-center">
          <Link to="/" className="text-sm text-[#E31E24] hover:underline font-medium">
            ← Ana Sayfaya Dön
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
